import React, { createContext, useContext } from 'react'

import { useMediaQuery, Theme } from '@mui/material'
import { TChildElementProps } from '../../types'

export type LayoutType = 'desktop' | 'mobile' | 'tablet'

const LayoutContext = createContext<LayoutType>('desktop')

//the component which requires this context will use it will return either desktop mobile or
//tablet depending upon the screen

export function useLayoutContext() {
  return useContext(LayoutContext)
}

export const LayoutContextProvider = ({ children }: TChildElementProps) => {
  const isMobileLayout = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const isDesktopLayout = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))
  // layout will have three values =>desktop mobile,tablet
  const layout = isMobileLayout ? 'mobile' : isDesktopLayout ? 'desktop' : 'tablet'

  return <LayoutContext.Provider value={layout}>{children}</LayoutContext.Provider>
}
